import React from 'react'
import ReviewsSummary from '../../../components/ReviewsSummary'
import ContentReviewCards from '../../../components/ContentReviewCards'
import ContentSectionHeader from '../../../components/ContentSectionHeader'
import { StaticQuery, graphql } from 'gatsby'
import FlexWrapper from '../../summary-reviews/components/FlexWrapper'

const ReviewsCarouselWidget = ({ data }) => {
  const reviews = data.allReviewCatfish
    ? data.allReviewCatfish.edges.map(({ node }) => node)
    : []

  return (
    <FlexWrapper>
      <ContentSectionHeader title="Reviews for Citygate" />
      <ContentReviewCards reviews={reviews} />
      <ReviewsSummary
        average={data.reviewSummaryCatfish.rating.toString()}
        total={data.reviewSummaryCatfish.review_count.toString()}
      />
    </FlexWrapper>
  )
}

const ReviewsCarousel = () => {
  const data = graphql`{
  reviewSummaryCatfish {
    review_count
    rating
  }
  allReviewCatfish(sort: {reviewDate: DESC}, limit: 10, filter: {rating: {eq: 5}}) {
    edges {
      node {
        id: _id
        name
        rating
        content
      }
    }
  }
}`

  return (
    <StaticQuery
      query={data}
      render={(data) => <ReviewsCarouselWidget data={data} />}
    />
  )
}

export default ReviewsCarousel
